import moment from "moment";

class DateUtils {
  static getLocalTime(rawDate: any): any {
    const usableRawDate = rawDate || undefined;
    return moment(usableRawDate).add(
      -new Date().getTimezoneOffset(),
      "minutes",
    );
  }

  static getUtcTime(rawDate: any): any {
    const usableRawDate = rawDate || undefined;
    return moment(usableRawDate).add(new Date().getTimezoneOffset(), "minutes");
  }

  static getLocalHour(hour: number): number {
    return moment("00", "HH")
      .add(-new Date().getTimezoneOffset(), "minutes")
      .add(hour, "hours")
      .get("hours");
  }

  static getUtcHour(hour: number): number {
    return moment("00", "HH")
      .add(new Date().getTimezoneOffset(), "minutes")
      .add(hour, "hours")
      .get("hours");
  }

  static getOrdinalDay(number: number) {
    switch (number) {
      case 1:
      case 21:
        return `${number}st`;
      case 2:
      case 22:
        return `${number}nd`;
      case 3:
      case 23:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }

  static toUnix(date: Date): number {
    return parseInt((date.getTime() / 1000).toFixed(0), 10);
  }
}

export default DateUtils;
